import * as tslib_1 from "tslib";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AppsService } from '../apps/apps.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../apps/apps.service";
var ChargebeeService = /** @class */ (function () {
    function ChargebeeService(http, appsService) {
        this.http = http;
        this.appsService = appsService;
        this.endpoints = {
            createPortalSession: '/dashboard/selfserve/v1/createportalsession',
            createCheckout: '/dashboard/selfserve/v1/createcheckout',
            cancelCheckout: '/dashboard/selfserve/v1/cancelcheckout'
        };
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
    }
    ChargebeeService.prototype.extractData = function (res) {
        var body = res;
        return body || {};
    };
    ChargebeeService.prototype.createPortalSession = function () {
        var endPoint = this.endpoints.createPortalSession;
        var dataToSend = {
            'params': {}
        };
        return this.http.get(endPoint, tslib_1.__assign({}, this.httpOptions, dataToSend)).pipe(map(this.extractData));
    };
    ChargebeeService.prototype.cancelCheckout = function () {
        var endPoint = this.endpoints.cancelCheckout;
        var dataToSend = {
            'params': {}
        };
        return this.http.get(endPoint, tslib_1.__assign({}, this.httpOptions, dataToSend)).pipe(map(this.extractData));
    };
    ChargebeeService.prototype.createCheckout = function (quantity) {
        var endPoint = this.endpoints.createCheckout;
        var dataToSend = {
            'params': {
                qty: quantity.toString()
            }
        };
        return this.http.get(endPoint, tslib_1.__assign({}, this.httpOptions, dataToSend)).pipe(map(this.extractData));
    };
    ChargebeeService.prototype.getProductionAppsAndSlotsCount = function () {
        return this.appsService.getAllApps().pipe(map(function (res) {
            if (res.is_error) {
                return res;
            }
            var companyData = res.api_response.company_details;
            var liveAppList = res.api_response.apps.filter(function (x) {
                return x.env === 'production' && x.app_state === 'production';
            });
            return {
                'apps': liveAppList.length,
                'slots': companyData.max_live_app_count
            };
        }), catchError(this.handleError('getProductionAppsAndSlotsCount')));
    };
    ChargebeeService.prototype.handleError = function (operation, result) {
        if (operation === void 0) { operation = 'operation'; }
        return function (error) {
            // TODO: send the error to remote logging infrastructure
            // TODO: better job of transforming error for user consumption
            // Let the app keep running by returning an empty result.
            return of(result);
        };
    };
    ChargebeeService.ngInjectableDef = i0.defineInjectable({ factory: function ChargebeeService_Factory() { return new ChargebeeService(i0.inject(i1.HttpClient), i0.inject(i2.AppsService)); }, token: ChargebeeService, providedIn: "root" });
    return ChargebeeService;
}());
export { ChargebeeService };
